import * as core from '../../../../../../../core'
import * as changeImpactStatus from '../change-impact-status'

export const RESOURCE = {
  payload: {
    description: 'Complete',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactStatus.RESOURCE.payload.partialId,
    }),
    id: 'Complete',
    name: 'Complete',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
